// source: core/protos/scene_annotations.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var core_protos_geometry_pb = require('../../core/protos/geometry_pb.js');
goog.object.extend(proto, core_protos_geometry_pb);
var core_protos_uuid_pb = require('../../core/protos/uuid_pb.js');
goog.object.extend(proto, core_protos_uuid_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.vertexvis.protobuf.core.CalloutAnnotationData', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.CustomAnnotationData', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.SceneAnnotation', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.SceneAnnotationData', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.SceneAnnotationData.SealedValueOptionalCase', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.SceneAnnotationSet', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.SceneAnnotationSet = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.SceneAnnotationSet, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.SceneAnnotationSet.displayName = 'proto.vertexvis.protobuf.core.SceneAnnotationSet';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.SceneAnnotation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.SceneAnnotation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.SceneAnnotation.displayName = 'proto.vertexvis.protobuf.core.SceneAnnotation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.SceneAnnotationData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.vertexvis.protobuf.core.SceneAnnotationData.oneofGroups_);
};
goog.inherits(proto.vertexvis.protobuf.core.SceneAnnotationData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.SceneAnnotationData.displayName = 'proto.vertexvis.protobuf.core.SceneAnnotationData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.CalloutAnnotationData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.CalloutAnnotationData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.CalloutAnnotationData.displayName = 'proto.vertexvis.protobuf.core.CalloutAnnotationData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.CustomAnnotationData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.CustomAnnotationData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.CustomAnnotationData.displayName = 'proto.vertexvis.protobuf.core.CustomAnnotationData';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.SceneAnnotationSet.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.SceneAnnotationSet.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.SceneAnnotationSet} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.SceneAnnotationSet.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && core_protos_uuid_pb.Uuid2l.toObject(includeInstance, f),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    modifiedAt: (f = msg.getModifiedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    name: (f = msg.getName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    suppliedId: (f = msg.getSuppliedId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotationSet}
 */
proto.vertexvis.protobuf.core.SceneAnnotationSet.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.SceneAnnotationSet;
  return proto.vertexvis.protobuf.core.SceneAnnotationSet.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.SceneAnnotationSet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotationSet}
 */
proto.vertexvis.protobuf.core.SceneAnnotationSet.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_uuid_pb.Uuid2l;
      reader.readMessage(value,core_protos_uuid_pb.Uuid2l.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setModifiedAt(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setName(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSuppliedId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.SceneAnnotationSet.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.SceneAnnotationSet.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.SceneAnnotationSet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.SceneAnnotationSet.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_uuid_pb.Uuid2l.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getModifiedAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSuppliedId();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional Uuid2l id = 1;
 * @return {?proto.vertexvis.protobuf.core.Uuid2l}
 */
proto.vertexvis.protobuf.core.SceneAnnotationSet.prototype.getId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid2l} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid2l, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid2l|undefined} value
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotationSet} returns this
*/
proto.vertexvis.protobuf.core.SceneAnnotationSet.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotationSet} returns this
 */
proto.vertexvis.protobuf.core.SceneAnnotationSet.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.SceneAnnotationSet.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.vertexvis.protobuf.core.SceneAnnotationSet.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotationSet} returns this
*/
proto.vertexvis.protobuf.core.SceneAnnotationSet.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotationSet} returns this
 */
proto.vertexvis.protobuf.core.SceneAnnotationSet.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.SceneAnnotationSet.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp modified_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.vertexvis.protobuf.core.SceneAnnotationSet.prototype.getModifiedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotationSet} returns this
*/
proto.vertexvis.protobuf.core.SceneAnnotationSet.prototype.setModifiedAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotationSet} returns this
 */
proto.vertexvis.protobuf.core.SceneAnnotationSet.prototype.clearModifiedAt = function() {
  return this.setModifiedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.SceneAnnotationSet.prototype.hasModifiedAt = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue name = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.vertexvis.protobuf.core.SceneAnnotationSet.prototype.getName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotationSet} returns this
*/
proto.vertexvis.protobuf.core.SceneAnnotationSet.prototype.setName = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotationSet} returns this
 */
proto.vertexvis.protobuf.core.SceneAnnotationSet.prototype.clearName = function() {
  return this.setName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.SceneAnnotationSet.prototype.hasName = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue supplied_id = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.vertexvis.protobuf.core.SceneAnnotationSet.prototype.getSuppliedId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotationSet} returns this
*/
proto.vertexvis.protobuf.core.SceneAnnotationSet.prototype.setSuppliedId = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotationSet} returns this
 */
proto.vertexvis.protobuf.core.SceneAnnotationSet.prototype.clearSuppliedId = function() {
  return this.setSuppliedId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.SceneAnnotationSet.prototype.hasSuppliedId = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.SceneAnnotation.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.SceneAnnotation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.SceneAnnotation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.SceneAnnotation.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && core_protos_uuid_pb.Uuid2l.toObject(includeInstance, f),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    modifiedAt: (f = msg.getModifiedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    suppliedId: (f = msg.getSuppliedId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.vertexvis.protobuf.core.SceneAnnotationData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotation}
 */
proto.vertexvis.protobuf.core.SceneAnnotation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.SceneAnnotation;
  return proto.vertexvis.protobuf.core.SceneAnnotation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.SceneAnnotation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotation}
 */
proto.vertexvis.protobuf.core.SceneAnnotation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_uuid_pb.Uuid2l;
      reader.readMessage(value,core_protos_uuid_pb.Uuid2l.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setModifiedAt(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSuppliedId(value);
      break;
    case 5:
      var value = new proto.vertexvis.protobuf.core.SceneAnnotationData;
      reader.readMessage(value,proto.vertexvis.protobuf.core.SceneAnnotationData.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.SceneAnnotation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.SceneAnnotation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.SceneAnnotation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.SceneAnnotation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_uuid_pb.Uuid2l.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getModifiedAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSuppliedId();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.vertexvis.protobuf.core.SceneAnnotationData.serializeBinaryToWriter
    );
  }
};


/**
 * optional Uuid2l id = 1;
 * @return {?proto.vertexvis.protobuf.core.Uuid2l}
 */
proto.vertexvis.protobuf.core.SceneAnnotation.prototype.getId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid2l} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid2l, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid2l|undefined} value
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotation} returns this
*/
proto.vertexvis.protobuf.core.SceneAnnotation.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotation} returns this
 */
proto.vertexvis.protobuf.core.SceneAnnotation.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.SceneAnnotation.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.vertexvis.protobuf.core.SceneAnnotation.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotation} returns this
*/
proto.vertexvis.protobuf.core.SceneAnnotation.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotation} returns this
 */
proto.vertexvis.protobuf.core.SceneAnnotation.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.SceneAnnotation.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp modified_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.vertexvis.protobuf.core.SceneAnnotation.prototype.getModifiedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotation} returns this
*/
proto.vertexvis.protobuf.core.SceneAnnotation.prototype.setModifiedAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotation} returns this
 */
proto.vertexvis.protobuf.core.SceneAnnotation.prototype.clearModifiedAt = function() {
  return this.setModifiedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.SceneAnnotation.prototype.hasModifiedAt = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue supplied_id = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.vertexvis.protobuf.core.SceneAnnotation.prototype.getSuppliedId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotation} returns this
*/
proto.vertexvis.protobuf.core.SceneAnnotation.prototype.setSuppliedId = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotation} returns this
 */
proto.vertexvis.protobuf.core.SceneAnnotation.prototype.clearSuppliedId = function() {
  return this.setSuppliedId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.SceneAnnotation.prototype.hasSuppliedId = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional SceneAnnotationData data = 5;
 * @return {?proto.vertexvis.protobuf.core.SceneAnnotationData}
 */
proto.vertexvis.protobuf.core.SceneAnnotation.prototype.getData = function() {
  return /** @type{?proto.vertexvis.protobuf.core.SceneAnnotationData} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.SceneAnnotationData, 5));
};


/**
 * @param {?proto.vertexvis.protobuf.core.SceneAnnotationData|undefined} value
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotation} returns this
*/
proto.vertexvis.protobuf.core.SceneAnnotation.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotation} returns this
 */
proto.vertexvis.protobuf.core.SceneAnnotation.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.SceneAnnotation.prototype.hasData = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.vertexvis.protobuf.core.SceneAnnotationData.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.vertexvis.protobuf.core.SceneAnnotationData.SealedValueOptionalCase = {
  SEALED_VALUE_OPTIONAL_NOT_SET: 0,
  CALLOUT: 1,
  CUSTOM_JSON: 2
};

/**
 * @return {proto.vertexvis.protobuf.core.SceneAnnotationData.SealedValueOptionalCase}
 */
proto.vertexvis.protobuf.core.SceneAnnotationData.prototype.getSealedValueOptionalCase = function() {
  return /** @type {proto.vertexvis.protobuf.core.SceneAnnotationData.SealedValueOptionalCase} */(jspb.Message.computeOneofCase(this, proto.vertexvis.protobuf.core.SceneAnnotationData.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.SceneAnnotationData.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.SceneAnnotationData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.SceneAnnotationData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.SceneAnnotationData.toObject = function(includeInstance, msg) {
  var f, obj = {
    callout: (f = msg.getCallout()) && proto.vertexvis.protobuf.core.CalloutAnnotationData.toObject(includeInstance, f),
    customJson: (f = msg.getCustomJson()) && proto.vertexvis.protobuf.core.CustomAnnotationData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotationData}
 */
proto.vertexvis.protobuf.core.SceneAnnotationData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.SceneAnnotationData;
  return proto.vertexvis.protobuf.core.SceneAnnotationData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.SceneAnnotationData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotationData}
 */
proto.vertexvis.protobuf.core.SceneAnnotationData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.CalloutAnnotationData;
      reader.readMessage(value,proto.vertexvis.protobuf.core.CalloutAnnotationData.deserializeBinaryFromReader);
      msg.setCallout(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.core.CustomAnnotationData;
      reader.readMessage(value,proto.vertexvis.protobuf.core.CustomAnnotationData.deserializeBinaryFromReader);
      msg.setCustomJson(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.SceneAnnotationData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.SceneAnnotationData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.SceneAnnotationData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.SceneAnnotationData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCallout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.CalloutAnnotationData.serializeBinaryToWriter
    );
  }
  f = message.getCustomJson();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.CustomAnnotationData.serializeBinaryToWriter
    );
  }
};


/**
 * optional CalloutAnnotationData callout = 1;
 * @return {?proto.vertexvis.protobuf.core.CalloutAnnotationData}
 */
proto.vertexvis.protobuf.core.SceneAnnotationData.prototype.getCallout = function() {
  return /** @type{?proto.vertexvis.protobuf.core.CalloutAnnotationData} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.CalloutAnnotationData, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.CalloutAnnotationData|undefined} value
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotationData} returns this
*/
proto.vertexvis.protobuf.core.SceneAnnotationData.prototype.setCallout = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.vertexvis.protobuf.core.SceneAnnotationData.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotationData} returns this
 */
proto.vertexvis.protobuf.core.SceneAnnotationData.prototype.clearCallout = function() {
  return this.setCallout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.SceneAnnotationData.prototype.hasCallout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CustomAnnotationData custom_json = 2;
 * @return {?proto.vertexvis.protobuf.core.CustomAnnotationData}
 */
proto.vertexvis.protobuf.core.SceneAnnotationData.prototype.getCustomJson = function() {
  return /** @type{?proto.vertexvis.protobuf.core.CustomAnnotationData} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.CustomAnnotationData, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.CustomAnnotationData|undefined} value
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotationData} returns this
*/
proto.vertexvis.protobuf.core.SceneAnnotationData.prototype.setCustomJson = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.vertexvis.protobuf.core.SceneAnnotationData.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotationData} returns this
 */
proto.vertexvis.protobuf.core.SceneAnnotationData.prototype.clearCustomJson = function() {
  return this.setCustomJson(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.SceneAnnotationData.prototype.hasCustomJson = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.CalloutAnnotationData.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.CalloutAnnotationData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.CalloutAnnotationData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.CalloutAnnotationData.toObject = function(includeInstance, msg) {
  var f, obj = {
    position: (f = msg.getPosition()) && core_protos_geometry_pb.Vector3f.toObject(includeInstance, f),
    icon: (f = msg.getIcon()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    primaryColor: (f = msg.getPrimaryColor()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    accentColor: (f = msg.getAccentColor()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.CalloutAnnotationData}
 */
proto.vertexvis.protobuf.core.CalloutAnnotationData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.CalloutAnnotationData;
  return proto.vertexvis.protobuf.core.CalloutAnnotationData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.CalloutAnnotationData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.CalloutAnnotationData}
 */
proto.vertexvis.protobuf.core.CalloutAnnotationData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_geometry_pb.Vector3f;
      reader.readMessage(value,core_protos_geometry_pb.Vector3f.deserializeBinaryFromReader);
      msg.setPosition(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setIcon(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPrimaryColor(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAccentColor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.CalloutAnnotationData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.CalloutAnnotationData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.CalloutAnnotationData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.CalloutAnnotationData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPosition();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_geometry_pb.Vector3f.serializeBinaryToWriter
    );
  }
  f = message.getIcon();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPrimaryColor();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAccentColor();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional Vector3f position = 1;
 * @return {?proto.vertexvis.protobuf.core.Vector3f}
 */
proto.vertexvis.protobuf.core.CalloutAnnotationData.prototype.getPosition = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3f} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.Vector3f, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.CalloutAnnotationData} returns this
*/
proto.vertexvis.protobuf.core.CalloutAnnotationData.prototype.setPosition = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.CalloutAnnotationData} returns this
 */
proto.vertexvis.protobuf.core.CalloutAnnotationData.prototype.clearPosition = function() {
  return this.setPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.CalloutAnnotationData.prototype.hasPosition = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue icon = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.vertexvis.protobuf.core.CalloutAnnotationData.prototype.getIcon = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.vertexvis.protobuf.core.CalloutAnnotationData} returns this
*/
proto.vertexvis.protobuf.core.CalloutAnnotationData.prototype.setIcon = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.CalloutAnnotationData} returns this
 */
proto.vertexvis.protobuf.core.CalloutAnnotationData.prototype.clearIcon = function() {
  return this.setIcon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.CalloutAnnotationData.prototype.hasIcon = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue primary_color = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.vertexvis.protobuf.core.CalloutAnnotationData.prototype.getPrimaryColor = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.vertexvis.protobuf.core.CalloutAnnotationData} returns this
*/
proto.vertexvis.protobuf.core.CalloutAnnotationData.prototype.setPrimaryColor = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.CalloutAnnotationData} returns this
 */
proto.vertexvis.protobuf.core.CalloutAnnotationData.prototype.clearPrimaryColor = function() {
  return this.setPrimaryColor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.CalloutAnnotationData.prototype.hasPrimaryColor = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue accent_color = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.vertexvis.protobuf.core.CalloutAnnotationData.prototype.getAccentColor = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.vertexvis.protobuf.core.CalloutAnnotationData} returns this
*/
proto.vertexvis.protobuf.core.CalloutAnnotationData.prototype.setAccentColor = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.CalloutAnnotationData} returns this
 */
proto.vertexvis.protobuf.core.CalloutAnnotationData.prototype.clearAccentColor = function() {
  return this.setAccentColor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.CalloutAnnotationData.prototype.hasAccentColor = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.CustomAnnotationData.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.CustomAnnotationData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.CustomAnnotationData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.CustomAnnotationData.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, ""),
    jsonData: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.CustomAnnotationData}
 */
proto.vertexvis.protobuf.core.CustomAnnotationData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.CustomAnnotationData;
  return proto.vertexvis.protobuf.core.CustomAnnotationData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.CustomAnnotationData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.CustomAnnotationData}
 */
proto.vertexvis.protobuf.core.CustomAnnotationData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setJsonData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.CustomAnnotationData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.CustomAnnotationData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.CustomAnnotationData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.CustomAnnotationData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getJsonData();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.vertexvis.protobuf.core.CustomAnnotationData.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vertexvis.protobuf.core.CustomAnnotationData} returns this
 */
proto.vertexvis.protobuf.core.CustomAnnotationData.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string json_data = 2;
 * @return {string}
 */
proto.vertexvis.protobuf.core.CustomAnnotationData.prototype.getJsonData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vertexvis.protobuf.core.CustomAnnotationData} returns this
 */
proto.vertexvis.protobuf.core.CustomAnnotationData.prototype.setJsonData = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


goog.object.extend(exports, proto.vertexvis.protobuf.core);
